import React from 'react';
import SelectInput from '../../../../components/basic/SelectInput';
import BranchMultiSelectAutoCompleteInput from '../../../../components/basic/BranchMultiSelectAutoCompleteInput';
import MultiStoreSearch from './MultiStoreSearch';
import { showStockOptions, itemsPerPageOptions, typeOptions } from '../data';
import "../styles/MainHeaderMenu.css";
import Button from '../../../../components/basic/Button';
import ArchiveIcon from '@mui/icons-material/Archive';

const Header = (props) => {
    const { branchOptions, componentName, search, clear, categoryOptions, download } = props;
    if (!branchOptions) return null;
    return (
        <div className="row">
            <div className="col-xs-12 col-sm-4">
                <MultiStoreSearch
                    name={`${componentName}Search`}
                    floatingLabelText="Search by Name, Brand, or SKU"
                    hintText="Search by Name, Brand, or SKU"
                    onSearch={search}
                    onClear={clear}
                    style={{ fontFamily: "Open Sans, Arial, Helvetica, sans-serif", fontSize: "18px", letterSpacing: "-0.25px", width: '350px' }}
                />
            </div>
            <div className="col-xs-12 col-sm-8">
                <div className="row">
                    <div className="col-sm-6 col-xl-4">
                        <SelectInput
                            defaultValue={typeOptions[0].value}
                            name={`${componentName}Type`}
                            fullWidth={true}
                            label="Select Type"
                            floatingLabelText="Select Type"
                            hintText="Select Type"
                            style={{ fontFamily: "Open Sans, Arial, Helvetica, sans-serif", fontSize: "16px", letterSpacing: "-0.25px" }}
                            options={typeOptions}
                            onSearch={search}
                        />
                    </div>
                    <div className="col-sm-6 col-xl-4">
                        <SelectInput
                            defaultValue={categoryOptions[0].value}
                            name={`${componentName}Category`}
                            fullWidth={true}
                            label="Select category"
                            floatingLabelText="Select category"
                            hintText="Select a category to display"
                            style={{ fontFamily: "Open Sans, Arial, Helvetica, sans-serif", fontSize: "16px", letterSpacing: "-0.25px" }}
                            options={categoryOptions}
                            onSearch={search}
                        />
                    </div>
                    <div className="col-sm-6 col-xl-4">
                        <BranchMultiSelectAutoCompleteInput
                            defaultValues={branchOptions}
                            name={`${componentName}Locations`}
                            fullWidth={true}
                            autoWidth={true}
                            label="Select Location(s)"
                            floatingLabelText="Select Location(s)"
                            hintText="Select locations to display"
                            style={{ fontFamily: "Open Sans, Arial, Helvetica, sans-serif", fontSize: "16px", letterSpacing: "-0.25px" }}
                            options={branchOptions}
                            fieldName={'Locations'}
                            search={search}
                        />
                    </div>
                    <div className="col-sm-6 col-xl-4">
                        <SelectInput
                            defaultValue={showStockOptions[1].value}
                            name={`${componentName}Stock`}
                            fullWidth={true}
                            label="Select stock to display"
                            floatingLabelText="Select stock to display"
                            hintText="Select stock to display"
                            style={{ fontFamily: "Open Sans, Arial, Helvetica, sans-serif", fontSize: "16px", letterSpacing: "-0.25px" }}
                            options={showStockOptions}
                            onChange={search}
                        />
                    </div>
                    <div className="col-sm-6 col-xl-4">
                        <SelectInput
                            defaultValue={itemsPerPageOptions[0].value}
                            name={`${componentName}ItemsPerPage`}
                            fullWidth={true}
                            label="Items per Page"
                            floatingLabelText="Items per Page"
                            hintText="Select # of items per page"
                            style={{ fontFamily: "Open Sans, Arial, Helvetica, sans-serif", fontSize: "16px", letterSpacing: "-0.25px" }}
                            options={itemsPerPageOptions}
                            onChange={search}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <Button
                            type="IconInButton"
                            className="pull-right btnNewBrandPOS"
                            label="Download CSV"
                            icon={<ArchiveIcon />}
                            onTouchTap={download}
                        />
                    </div>
                    <div className="col-xs-12 mt-2">
                        <p className="pull-right font-italic">Note: This may take a few minutes.</p>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Header;
